import { A4uFileJson as IconComponent } from '@adobe/react-spectrum-workflow/dist/FileJson.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function FileJson(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}